import { computed } from 'vue';
import { Routes } from '@/models/router/router.interface';
import { ModalActAccessStates } from '@/models/modal/modal.enum';
import actPresenter from '@/presenters/act-presenter';
import store from '@/store';
import actStore from '@/store/act';

export default class ActAccessOverviewCode {

	public isActAccessModalActive = computed((): boolean => {
		return actStore.actGetters.modalActAccessState() !== ModalActAccessStates.INACTIVE;
	});

	public mounted(): void {
		void actPresenter.retrieveActEntries();
		void actPresenter.retrieveActAvailableDashboards();
	}

	public navigateToUserActionsPage(): void {
		store.mutations.setCurrentRoute(Routes.USER_ACTIONS);
	}
}
